export default {
    isLoading: false,
};